import { helperServices } from "../../shared/helper";
import history from "../../shared/utils/history";
import { apiFetch } from "../../shared/helper/apiFetch";

const basePath = "/api";

// -------------------- Logout --------------------
function logout() {
  localStorage.removeItem("user");
  history.push("/");
  window.location.reload();
}

// -------------------- Handle Response --------------------
function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    const token = response.headers.get("Authorization");

    if (token) {
      localStorage.setItem("token", JSON.stringify(token));
    }

    if (!response.ok) {
      if (response.status === 401) {
        logout(); // auto logout if 401 response returned from API
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

// -------------------- Helper: Build Headers --------------------
function buildHeaders() {
  const accessToken = helperServices.getAuthorization() || "";
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
}

// -------------------- Get All Bed Info --------------------
function getAllBedInfo(searchText) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(searchText),
  };

  const url = `${basePath}/master/beds`;
  return apiFetch(url, requestOptions);
}

// -------------------- Add New Bed --------------------
function addNewBeds(bedInfo) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(bedInfo),
  };

  const url = `${basePath}/master/bed`;
  return apiFetch(url, requestOptions);
}

// -------------------- Update Bed --------------------
function updateBed(bedInfo) {
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(bedInfo),
  };

  const url = `${basePath}/master/bed`;
  return apiFetch(url, requestOptions);
}

// -------------------- Export --------------------
const bedServices = {
  logout,
  handleResponse,
  getAllBedInfo,
  addNewBeds,
  updateBed,
};

export default bedServices;
